export const LOAD_PURCHASE_METADATA_SUCCESS = 'LOAD_PURCHASE_METADATA_SUCCESS';
export const LOAD_PURCHASE_METHODS_SUCCESSV25 = 'LOAD_PURCHASE_METHODS_SUCCESSV25';

export const SELECT_PURCHASE_METHOD = 'SELECT_PURCHASE_METHOD_V25';
export const SELECT_PAYMENT_FREQUENCY = 'SELECT_PAYMENT_FREQUENCY_V25';
export const SELECT_TERM = 'SELECT_TERM_V25';
export const SELECT_KM_PLAN = 'SELECT_KM_PLAN_V25';

export const SET_CASH_DOWN = 'SET_CASH_DOWN_V25';
export const SET_TRADE_IN = 'SET_TRADE_IN_V25';
export const SET_LIEN = 'SET_LIEN_V25';
export const SET_EXTERIOR_COLOUR_AMOUNTS = 'SET_EXTERIOR_COLOUR_AMOUNTS_V25';
export const SET_INTERIOR_COLOUR_AMOUNTS = 'SET_INTERIOR_COLOUR_AMOUNTS_V25';
export const SET_OPTIONS_AMOUNTS = 'SET_OPTIONS_AMOUNTS_V25';

export const SET_DELIVERY_FEE = 'SET_DELIVERY_FEE_V25';
export const SET_DEPOSIT = 'SET_DEPOSIT_V25';

export const SET_TAXES_INCLUDED = 'SET_TAXES_INCLUDED_V25';

export const SELECT_OPTIONS_RESOLUTION = 'SELECT_OPTIONS_RESOLUTION_V25';

export const RESET_SELECTED_INCENTIVE_REBATES = 'RESET_SELECTED_INCENTIVE_REBATES_V25';

export const SET_PAYMENT_OPTIONS_FETCH_STATUS = 'SET_PAYMENT_OPTIONS_FETCH_STATUS';

export const QUOTE_UPDATE_TYPES = [
    SELECT_PURCHASE_METHOD,
    SELECT_PAYMENT_FREQUENCY,
    SELECT_TERM,
    SELECT_KM_PLAN,
    SET_CASH_DOWN,
    SET_TRADE_IN,
    SET_LIEN,
    SET_TAXES_INCLUDED,
    SELECT_OPTIONS_RESOLUTION,
    SET_PAYMENT_OPTIONS_FETCH_STATUS,
];

export default {
    LOAD_PURCHASE_METHODS_SUCCESSV25,
    SELECT_PURCHASE_METHOD,
    SELECT_PAYMENT_FREQUENCY,
    SELECT_TERM,
    SELECT_KM_PLAN,
    SET_CASH_DOWN,
    SET_TRADE_IN,
    SET_LIEN,
    SET_EXTERIOR_COLOUR_AMOUNTS,
    SET_INTERIOR_COLOUR_AMOUNTS,
    SET_OPTIONS_AMOUNTS,
    SET_DELIVERY_FEE,
    SET_DEPOSIT,
    SET_TAXES_INCLUDED,
    SELECT_OPTIONS_RESOLUTION,
    RESET_SELECTED_INCENTIVE_REBATES,
    QUOTE_UPDATE_TYPES,
    SET_PAYMENT_OPTIONS_FETCH_STATUS,
};
